module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAABGdBTUEAALGPC/xhBQAAASlJREFUOBGlkr0KwjAUhZtQ6eLkIDh0cvAdFARXJ3FyL30JX8BnkNLdybGrm+/g3EFwcBdL8ZzYtDa2pmAg3p/c73hvGsf5c4kkSbw0TQ9SyigMw6SLXhRFyzzPQ9/3NxLwHtAKiSMPbAIFfCRDVrquu0NwxfZsIh+wR4asgOPEcTzJsuwEd4T9wDhrc5wGeBEEwUUJ2ETaYHKlQJsI8xwNRret/pl5rpoAE8Y4T+aweticuQbz4EuAyULkDHfAGOsOeMqZ32H1Kyu38tDyWAjRrzJOn7mPuHS/OjAu7FZUDmEbv06tAwPmzHNuwK3vpOygAS4vzLjYWidK4Besh20TEV3gXyIStztDQeMj0aC2/Ix8C4jVncBO1Rm62LJFXWizrCVjq+t0/gLxNdlR90z/8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ucenter/close_icon.png
// module id = 506
// module chunks = 0 1